import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as commonActions from '../common/redux/actions';
import { GEditor } from './index';
import '../../webconnect';
import Helmet from 'react-helmet';
import cookie from 'react-cookies';

export class DefaultPage extends Component {
  static propTypes = {
    editor: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    flag: false,
  };

  async componentDidMount() {
    const { match, location, actions } = this.props;
    const { projectId, pageId, version } = match.params;
    let searchParams = new URLSearchParams(this.props.location.search);
    actions.loadProject({ projectId, version });
    actions.loadInstalledPlugins({ projectId, version });
    actions.loadProjectAssets({ projectId, version });
    actions.loadExternalApis({ projectId, version });
    actions.loadDefaultPage({ projectId, version });
    actions.fetchPageDetail({ pageId, projectId, version });
    if (searchParams.has('open-modal') && searchParams.get('open-modal') === 'create-page') {
      actions.toggleCreatePage({});
      actions.togglePageModal();
    }
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const { projectId, pageId, version } = this.props.match.params;
    let currentPageId = nextProps.match.params.pageId;
    if (currentPageId !== pageId) {
      this.props.actions.fetchPageDetail({ currentPageId, projectId, version });
    }
    return true;
  }

  showGEditor = () => {
    const { editor, match, common, actions } = this.props;
    const { versions } = common;
    const { project, assets, defaultPage, plugins, showBuilderCanvasLoader } = editor;
    if (project && defaultPage) {
      const { projectId, pageId, version } = match.params;
      const uri =
        defaultPage.uuid === pageId
          ? `v${version}/pages/default-page/content`
          : `v${version}/pages/${pageId}/content`;
      let token = cookie.load('token');
      if (!token) {
        token = '';
      }
      return (
        <GEditor
          projectId={projectId}
          version={version}
          actions={actions}
          uri={uri}
          project={project}
          versions={versions}
          pageId={pageId}
          assets={assets}
          plugins={plugins}
          editor={editor}
          token={token}
          showBuilderCanvasLoader={showBuilderCanvasLoader}
        />
      );
    } else {
      return <div>Loader</div>;
    }
  };

  render() {
    const { editor } = this.props;
    console.log('intoodefault', this.props);
    const { pageDetail, loadCollectionsPending, loadExternalApisPending } = editor || '';

    if (loadCollectionsPending) {
      return <p>Loading</p>;
    }
    if (loadExternalApisPending) {
      return <p>Loading</p>;
    }
    return (
      <Fragment>
        <Helmet>
          <title>
            {pageDetail ? `${pageDetail.name} |` : ''} DrapCode | Build Awesome Web Applications
          </title>
        </Helmet>
        {this.showGEditor()}
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    editor: state.editor,
    home: state.home,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);
